import * as types from "../../_constants/types";

export default (state = { value: "" }, action) => {
    switch (action.type) {
        case types.SEARCH_MESSAGE_LOAD:
            return { value: action.results };

        case types.RESET:
        case types.SEARCH_MESSAGE_RESET: {
            return { value: "" };
        }
        default:
            return state;
    }
};
